export const categories = [
  {
    slug: 'mingxing-bagua',
    name: '明星八卦',
    description: '娱乐圈台前幕后的最新动态，感情、作品、行程一网打尽。',
    intro: '从剧组花絮到红毯动向，我们把明星们的公开动态整理成清晰的资讯线，让你不用翻遍全网也能跟上节奏。',
    icon: 'ri-star-smile-line',
  },
  {
    slug: 'wanghong-fanche',
    name: '网红翻车',
    description: '带货、直播、人设相关的争议事件，理性围观不站队。',
    intro: '网红经济起落最快，我们只呈现可核实的公开信息与多方说法，帮你在热闹里保持清醒。',
    icon: 'ri-alarm-warning-line',
  },
  {
    slug: 'suran-tougao',
    name: '素人投稿',
    description: '来自普通网友的真实讲述，生活里的意外比剧本更抓人。',
    intro: '每一个普通人都可能遇到故事。这里收下网友的投稿，用第一人称把生活里的意外讲给你听。',
    icon: 'ri-chat-quote-line',
  },
  {
    slug: 'quannei-neimu',
    name: '圈内内幕',
    description: '来自行业从业者的匿名分享，还原事件背后的运作方式。',
    intro: '镜头之外的流程、规则与博弈，来自从业者的匿名讲述，帮你理解一个事件究竟是怎么发生的。',
    icon: 'ri-eye-off-line',
  },
];